import type { Geolocation } from ".."

export const extractLatlngFromBrowserState = ({
  browserState,
}: {
  browserState: Geolocation.BrowserState
}): Geolocation.Latlng => {
  if (!browserState.position) {
    throw new Error(
      `getLatlng: Can't determine position based on browser config and position not provided.`
    )
  }

  return {
    lat: browserState.position.coords.latitude,
    lng: browserState.position.coords.longitude,
  }
}
